// extracted by mini-css-extract-plugin
export default {"burger":"styles_burger__4YzNC","burger_header":"styles_burger_header__Ryr2p","burger_nav":"styles_burger_nav__WWf-o","eclipse_drive_link":"styles_eclipse_drive_link__RK4lX"};